import { Link } from "@inertiajs/react";
import ContentLayout from "../shared/ContentLayout";
import PageHeader from "../shared/PageHeader";
import AnnouncementCard from "../AnnouncementCard";
import { formatDate } from "./dates";

export default function AnnouncementsIndex({ announcements }: any) {
  const renderBreadcrumbs = () => (
    <div className="breadcrumbs text-sm">
      <ul>
        <li>
          <Link href="/" className="link link-primary">Home</Link>
        </li>
        <li><span>Announcements</span></li>
      </ul>
    </div>
  );

  const description = announcements.length > 0
    ? `Last published on ${formatDate(announcements[0].published_at)}`
    : undefined;

  return (
    <ContentLayout breadcrumbs={renderBreadcrumbs()}>
      <div className="p-3 sm:p-4 max-w-4xl">
        <PageHeader title="Announcements" description={description} />
        <div className="flex flex-col gap-3">
          {announcements.map((announcement: any) => (
            <AnnouncementCard
              key={`announcement-card-${announcement.id}`}
              announcement={announcement}
            />
          ))}
        </div>
      </div>
    </ContentLayout>
  );
}